import { apiClientV2 } from '@/services/rest-api/apiClient'
const baseURL = process.env.VUE_APP_API_ORDER_URL

const _get = async (queryParamFilters, queryParam, setParams, setMetadata) => {
  const params = {
    limit: queryParam.limit,
    page: queryParam.page,
    sorts: queryParam?.sorts?.length > 0 ? queryParam.sorts : undefined,
    search: queryParam?.search || undefined,
    filters: queryParamFilters || undefined,
  }

  setParams?.(params)

  const response = await apiClientV2({
    baseURL,
    method: 'GET',
    url: '/delivery-order-template',
    params: params,
  })

  setMetadata?.(response?.data.metadata)

  return response?.data
}

export const get = (queryParamFilters, setParams, setMetadata) => async (queryParam) =>
  await _get(queryParamFilters, queryParam, setParams, setMetadata)

export const show = async (id) => {
  const response = await apiClientV2({
    baseURL,
    method: 'GET',
    url: `/delivery-order-template/${id}`,
  })

  return response?.data
}

export const store = async (data) => {
  const response = await apiClientV2({
    baseURL,
    method: 'POST',
    url: '/delivery-order-template',
    data,
  })

  return response?.data
}

export const update = async (id, data) => {
  const response = await apiClientV2({
    baseURL,
    method: 'PATCH',
    url: `/delivery-order-template/${id}`,
    data,
  })

  return response?.data
}

export const deleteMany = async (data) => {
  const response = await apiClientV2({
    baseURL,
    method: 'POST',
    url: `/delivery-order-template/delete`,
    data,
  })

  return response?.data
}

export const _getLoad = async (templateId, queryParam) => {
  const params = {
    limit: queryParam.limit,
    page: queryParam.page,
    sorts: queryParam?.sorts?.length > 0 ? queryParam.sorts : undefined,
    search: queryParam?.search || undefined,
  }

  const response = await apiClientV2({
    baseURL,
    method: 'GET',
    url: `/delivery-order-template/${templateId}/load`,
    params: params,
  })

  return response?.data
}

export const getLoad = (templateId) => async (queryParam) => await _getLoad(templateId, queryParam)

export const _showLoad = async (templateId, loadId) => {
  const response = await apiClientV2({
    baseURL,
    method: 'GET',
    url: `/delivery-order-template/${templateId}/load/${loadId}`,
  })

  return response?.data
}

export const showLoad = (templateId) => async (loadId) => await _showLoad(templateId, loadId)

export const _storeLoad = async (templateId, data) => {
  const response = await apiClientV2({
    baseURL,
    method: 'POST',
    url: `/delivery-order-template/${templateId}/load`,
    data,
  })

  return response?.data
}

export const storeLoad = (templateId) => async (data) => await _storeLoad(templateId, data)

export const _updateLoad = async (templateId, loadId, data) => {
  const response = await apiClientV2({
    baseURL,
    method: 'PATCH',
    url: `/delivery-order-template/${templateId}/load/${loadId}`,
    data,
  })

  return response?.data
}

export const updateLoad = (templateId) => async (loadId, data) => await _updateLoad(templateId, loadId, data)

export const _deleteSingleLoad = async (templateId, loadId) => {
  const response = await apiClientV2({
    baseURL,
    method: 'DELETE',
    url: `/delivery-order-template/${templateId}/load/${loadId}`,
  })

  return response?.data
}

export const deleteSingleLoad = (templateId) => async (loadId) => await _deleteSingleLoad(templateId, loadId)
